export function pageChangeEffect(pageTitle: string, productName?: string) {
  return function() {
    document.title = productName ? `${productName} - ${pageTitle}` : `Wonderlic - ${pageTitle}`;
  };
}
